import {
  Component,
  ChangeDetectionStrategy,
  input,
  output,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

export interface PillTabOption {
  label: string;
  value: string | number;
}

export interface PillTabChangeEvent {
  label: string;
  value: string | number;
  index: number;
}

@Component({
  selector: 'lib-pill-tabs',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  template: `
    <div class="pill-tabs-container">
      @for (option of options(); track option.value; let i = $index) {
        <button
          type="button"
          class="pill-tab"
          [class.active]="activeIndex() === i"
          (click)="selectTab(i)"
        >
          {{ option.label | transloco }}
        </button>
      }
    </div>
  `,
  styles: [`
    .pill-tabs-container {
      display: inline-flex;
      background: #EFF2FB;
      border-radius: 24px;
      padding: 4px;
      gap: 4px;
    }

    .pill-tab {
      padding: 10px 28px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.25s ease;
      border: none;
      background: transparent;
      color: #94A3B8;
      white-space: nowrap;
    }

    .pill-tab:hover:not(.active) {
      color: #64748B;
    }

    .pill-tab.active {
      background: #6887ED;
      color: #FFFFFF;
      box-shadow: 0 2px 8px rgba(104, 135, 237, 0.25);
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillTabsComponent {
  options = input<PillTabOption[]>([]);
  defaultIndex = input<number>(0);
  tabChange = output<PillTabChangeEvent>();

  activeIndex = signal<number>(0);

  ngOnInit() {
    this.activeIndex.set(this.defaultIndex());
  }

  selectTab(index: number) {
    this.activeIndex.set(index);
    const option = this.options()[index];
    this.tabChange.emit({
      label: option.label,
      value: option.value,
      index,
    });
  }
}
